/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JsonApiListResourceMetadataBase } from '@irian-ro/abstract-resource';

export class MasterRoutingSolutionsMetadataModel extends JsonApiListResourceMetadataBase {
  preferredExists : boolean | undefined = undefined;
}
